/**
 * Entfernt Tracking-Parameter (utm, gclid & Co.) aus der URL, BEVOR der TOSC5 bootet,
 * und bootet TOSC5 danach selbst. TOSC5 kapselt beim App-Start alle fremden
 * Query-Parameter in seinen URL-State, schleift sie in alle internen Navigations-Links
 * mit und schreibt sie sogar nach einem replaceState wieder in die Adresszeile zurück
 * (siehe OOEAT-7033). Deshalb ist der TOSC5-Loader in Tosc5/Show.html NICHT statisch
 * eingebunden, sondern steckt als data-tosc5-loader am Target-Div und wird von hier
 * aus injiziert – erst wenn die Strip-Entscheidung gefallen ist.
 *
 * Fail-safe Richtung: im Zweifel wird NICHT gestrippt (die TOSC5-Links tragen die
 * Parameter dann wie bisher mit), damit die Kampagnen-Attribution nie kaputtgeht:
 *
 * - Solange die Consent-Entscheidung offen ist, wird nicht gestrippt: der Consent-Accept
 *   macht ein location.reload() (siehe cookieConsent.js), und gtag braucht die
 *   Original-URL nach dem Reload noch.
 * - Matomo trackt immer (ohne Consent cookieless): solange matomo.js die _paq-Queue noch
 *   nicht abgearbeitet hat (_paq noch plain Array), wird die Original-URL per
 *   setCustomUrl VOR dem trackPageView in die Queue gestellt.
 * - gtag.js/gtm.js lesen die URL erst, wenn sie geladen sind: gestrippt wird erst,
 *   sobald das googletagmanager-Script laut Resource Timing geladen ist. Bewusst
 *   Polling statt load-Event: das Event feuert nicht mehr, wenn das Script beim
 *   Cleaner-Start schon geladen war (z.B. aus dem HTTP-Cache).
 */
(function () {
    'use strict';

    var TRACKING_PARAM = /^(utm_|mtm_|gad_|gclid$|gbraid$|wbraid$|fbclid$|msclkid$)/;

    var debug = function (msg) {
        if (window.console && console.log) {
            console.log('%c TTG Tosc5UrlCleaner ', 'background: #0080a3; color: #fff', msg);
        }
    };

    // TOSC5-Loader injizieren – muss in JEDEM Ausgang dieses Scripts genau einmal passieren
    var bootTosc5 = function () {
        var target = document.getElementById('tosc5target');
        if (!target || !target.getAttribute('data-tosc5-loader') || window.ttgTosc5LoaderInjected) {
            return;
        }
        window.ttgTosc5LoaderInjected = true;
        var loader = document.createElement('script');
        loader.async = true;
        loader.src = target.getAttribute('data-tosc5-loader');
        document.head.appendChild(loader);
    };

    try {
        if (!window.location.search || !window.history || !window.URL) {
            bootTosc5();

            return;
        }

        // Consent-Entscheidung noch offen? Original-URL für den Consent-Reload behalten.
        if (document.cookie.indexOf('cookieConsented-analysis=') === -1) {
            debug('kein Strip: Consent-Entscheidung offen, Original-URL wird für den Consent-Reload gebraucht');
            bootTosc5();

            return;
        }

        var cleanUrl = new URL(window.location.href);
        var removed = false;
        Array.from(cleanUrl.searchParams.keys()).forEach(function (key) {
            if (TRACKING_PARAM.test(key)) {
                cleanUrl.searchParams.delete(key);
                removed = true;
            }
        });

        if (!removed) {
            bootTosc5();

            return;
        }

        // Matomo: Landing-URL sichern, falls matomo.js die Queue noch nicht abgearbeitet hat
        if (Array.isArray(window._paq)) {
            window._paq.unshift(['setCustomUrl', window.location.href]);
        }

        var strip = function () {
            window.history.replaceState(null, '', cleanUrl.toString());
            debug('Tracking-Parameter aus der URL entfernt');
        };

        var gtagPresent = document.querySelector('script[src*="googletagmanager.com"]') !== null;
        var gtagHasLoaded = function () {
            if (window.google_tag_manager) {
                return true;
            }

            return !!window.performance && performance.getEntriesByType('resource').some(function (entry) {
                return entry.name.indexOf('googletagmanager.com') !== -1 && entry.responseEnd > 0;
            });
        };

        if (!gtagPresent || gtagHasLoaded()) {
            strip();
            bootTosc5();

            return;
        }

        debug('warte auf gtag, damit die Kampagnen-Parameter dort ankommen … (TOSC5 bootet danach)');
        var attempts = 0;
        var timer = window.setInterval(function () {
            try {
                attempts++;
                if (gtagHasLoaded()) {
                    window.clearInterval(timer);
                    strip();
                    bootTosc5();
                } else if (attempts >= 25) {
                    // ponytail: nach 5s aufgeben – URL bleibt dann wie bisher ungestrippt (fail-safe,
                    // z.B. wenn ein Adblocker gtag blockt und Resource Timing nie einen Treffer liefert)
                    window.clearInterval(timer);
                    debug('kein Strip: gtag wurde nicht geladen (Adblocker?)');
                    bootTosc5();
                }
            } catch (e) {
                window.clearInterval(timer);
                bootTosc5();
                throw e;
            }
        }, 200);
    } catch (e) {
        // TOSC5 darf nie an einem Cleaner-Fehler scheitern
        bootTosc5();
        throw e;
    }
})();
